import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import ReactSelect from "react-select";
import {
    AdminEmployeeActiveList, GetDirectorReportEmployee, HodAparReport, DirectorAparReport, HodEmployeeActiveList,
    findAparSpecificView
} from "../../Repository/Api";
import { NonEmptyValidation } from "../../Store/validate";
import { FinancialYearOptions } from "../Common/FinancialYear";
import { errorMsg, successMsg } from "../Toastify";
const HodAPAReportGenerate = () => {
    const { first_name, access_token, department } = useSelector((state) => state?.auth?.auth);
    const token = access_token
    const { pathname } = useLocation()
    const { id } = useParams()
    const isHod = pathname.includes('Hod')
    const isDirector = pathname.includes('Director')
    const isAdmin = pathname.includes('admin')
    const navigate = useNavigate()
    function isEmpty(value) {
        return (value == null || value === undefined || (typeof value === "string" && value.trim().length === 0));
    }
    const isHodGenerate = (isHod && isEmpty(id))
    useEffect(() => {
        getEmployeeList();
        getSpecificApar()
    }, [id]);
    const [apply, setApply] = useState({});
    const [apply1, setApply1] = useState({});
    const directorscore = apply?.director_final_score > 0
    const [validation, setValidation] = useState({});

    const [employee, setEmployee] = useState([]);
    const setData = (e, key) => {

        setApply({ ...apply, [key]: e });
        if (validation[key]) setValidation({ ...validation, [key]: false });
    };
    const setData1 = (e, key) => {

        setApply1({ ...apply1, [key]: e });
        if (validation[key]) setValidation({ ...validation, [key]: false });
    };
    const getSpecificApar = async () => {
        const response = await findAparSpecificView(id, token)
        if (response && response?.statusCode === 200) {
            setApply(response?.data)
        }
    }

    const getEmployeeList = async () => {
        const response = pathname?.includes('Director') ? await GetDirectorReportEmployee(token) : pathname.includes('Hod') ? await HodEmployeeActiveList(token) : pathname?.includes('admin') && await AdminEmployeeActiveList(token)
        if (response && response.statusCode === 200) {
            let employee = pathname?.includes('Director') ?
                response?.data?.map((label) => ({
                    label: label.name,
                    value: label.id,
                })) :
                pathname?.includes('Hod') ?
                    response?.data?.employee_details?.map((label) => ({
                        label: label.first_name + ' ' + label.last_name,
                        value: label.id,
                    })) :
                    pathname?.includes('admin') ?
                        response?.data?.employee_details?.map((label) => ({
                            label: label.first_name + ' ' + label.last_name,
                            value: label.id,
                        })) : ''
            setEmployee(employee);
        } else {
            errorMsg(response.message);
        }
    };
    const handleDirectorSubmit = async (e) => {
        e.preventDefault();
        let validate = {};
        assessment_of_work.map((item, i) => (validate[item?.key + 1] = NonEmptyValidation(apply1[item?.key + 1])))
        assessment_of_personal.map((item, i) => (validate[item?.key + 1] = NonEmptyValidation(apply1[item?.key + 1])))
        assessment_of_functional.map((item, i) => (validate[item?.key + 1] = NonEmptyValidation(apply1[item?.key + 1])))
        setValidation(validate);

        if (Object.values(validate).every((v) => v.status === true)) {
            if (apply1?.director_condition_acknowledge) {
                const Payload = {
                    id: id,
                    assessment_of_work: {
                        accomplishment_of_planned_work: apply1?.accomplishment_of_planned_work1,
                        quality_of_output: apply1?.quality_of_output1,
                        analytical_ability: apply1?.analytical_ability1,
                        accomplishment_of_exceptional_work: apply1?.accomplishment_of_exceptional_work1,
                    },
                    assessment_of_personal_attributes: {
                        attitude_to_work: apply1?.attitude_to_work1,
                        sense_of_responsibility: apply1?.sense_of_responsibility1,
                        maintenance_of_discipline: apply1?.maintenance_of_discipline1,
                        communication_skills: apply1?.communication_skills1,
                        leadership_qualities: apply1?.leadership_qualities1,
                        capacity_to_work_in_team_spirit: apply1?.capacity_to_work_in_team_spirit1,
                        capacity_to_work_in_time_limit: apply1?.capacity_to_work_in_time_limit1,
                        interpersonal_relations: apply1?.interpersonal_relations1
                    },
                    assessment_of_functional_competency: {
                        knowledge_of_rules: apply1?.knowledge_of_rules1,
                        strategic_planning_activity: apply1?.strategic_planning_activity1,
                        decision_making_ability: apply1?.decision_making_ability1,
                        coordination_ability: apply1?.coordination_ability1,
                        ability_to_motivate_subordinates: apply1?.ability_to_motivate_subordinates1
                    },
                    director_condition_acknowledge: apply1?.director_condition_acknowledge
                };
                const response = await DirectorAparReport(Payload, token);
                if (response && response.statusCode === 200) {
                    successMsg(response.message);
                    navigate(-1)
                } else {
                    errorMsg(response.message);
                }
            } else {
                errorMsg('Please Accept the terms')
            }
        }
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        let validate = {};
        validate.employee_id = NonEmptyValidation(apply?.employee_id);
        validate.academic_year = NonEmptyValidation(apply?.academic_year);
        if (isHod) {
            assessment_of_work.map((item, i) => (validate[item?.key] = NonEmptyValidation(apply[item?.key])))
            assessment_of_personal.map((item, i) => (validate[item?.key] = NonEmptyValidation(apply[item?.key])))
            assessment_of_functional.map((item, i) => (validate[item?.key] = NonEmptyValidation(apply[item?.key])))
            selectInput4.map((item, i) => (validate[item?.key] = NonEmptyValidation(apply[item?.key])))
        }
        if (isDirector) {
            assessment_of_work.map((item, i) => (validate[item?.key + 1] = NonEmptyValidation(apply[item?.key + 1])))
            assessment_of_personal.map((item, i) => (validate[item?.key + 1] = NonEmptyValidation(apply[item?.key + 1])))
            assessment_of_functional.map((item, i) => (validate[item?.key + 1] = NonEmptyValidation(apply[item?.key + 1])))
        }
        setValidation(validate);

        if (Object.values(validate).every((v) => v.status === true)) {
            if (apply?.condition_acknowledge) {
                const Payload = {
                    employee_id: apply?.employee_id?.value,
                    academic_year: apply?.academic_year,
                    assessment_of_work: {
                        accomplishment_of_planned_work: apply?.accomplishment_of_planned_work,
                        quality_of_output: apply?.quality_of_output,
                        analytical_ability: apply?.analytical_ability,
                        accomplishment_of_exceptional_work: apply?.accomplishment_of_exceptional_work,
                    },
                    assessment_of_personal_attributes: {
                        attitude_to_work: apply?.attitude_to_work,
                        sense_of_responsibility: apply?.sense_of_responsibility,
                        maintenance_of_discipline: apply?.maintenance_of_discipline,
                        communication_skills: apply?.communication_skills,
                        leadership_qualities: apply?.leadership_qualities,
                        capacity_to_work_in_team_spirit: apply?.capacity_to_work_in_team_spirit,
                        capacity_to_work_in_time_limit: apply?.capacity_to_work_in_time_limit,
                        interpersonal_relations: apply?.interpersonal_relations
                    },
                    assessment_of_functional_competency: {
                        knowledge_of_rules: apply?.knowledge_of_rules,
                        strategic_planning_activity: apply?.strategic_planning_activity,
                        decision_making_ability: apply?.decision_making_ability,
                        coordination_ability: apply?.coordination_ability,
                        ability_to_motivate_subordinates: apply?.ability_to_motivate_subordinates
                    },
                    views_of_points: {
                        teacher_possess_upto_date_knowledge: apply?.teacher_possess_upto_date_knowledge,
                        teacher_has_completed_the_work_assigned: apply?.teacher_has_completed_the_work_assigned,
                        teacher_has_capacity_for_getting_work_with_subordinates: apply?.teacher_has_capacity_for_getting_work_with_subordinates,
                        teacher_bearing_towards_trainees_and_his_accessibility: apply?.teacher_bearing_towards_trainees_and_his_accessibility,
                        teacher_maintained_a_reputation_for_integrity: apply?.teacher_maintained_a_reputation_for_integrity,
                        any_incident_occured_during_the_period: apply?.any_incident_occured_during_the_period
                    },
                    condition_acknowledge: apply?.condition_acknowledge
                };
                const response = await HodAparReport(Payload, token);
                if (response && response.statusCode === 200) {
                    successMsg(response.message);
                    navigate(-1)
                } else {
                    errorMsg(response.message);
                }
            } else {
                errorMsg('Please Accept the terms')
            }
        }
    };
    const assessment_of_work = [
        {
            s_no: '(i)',
            content: " Accomplishment of planned work / work alloted as per subjects alloted",
            key: "accomplishment_of_planned_work"
        },
        {
            s_no: '(ii)',
            content: "  Quality Of Output",
            key: "quality_of_output"
        },
        {
            s_no: '(iii)',
            content: "Analytical abilitty",
            key: "analytical_ability"
        },
        {
            s_no: '(iv)',
            content: "Accomplishment of exceptional work / unforeseen tasks performed",
            key: "accomplishment_of_exceptional_work"
        }
    ]
    const assessment_of_personal = [
        {
            s_no: '(i)',
            content: "Attitude to work",
            key: "attitude_to_work"
        },
        {
            s_no: '(ii)',
            content: "Sense of Responsibility",
            key: "sense_of_responsibility"
        },
        {
            s_no: '(iii)',
            content: "Maintenance Of Discipline",
            key: "maintenance_of_discipline"
        },
        {
            s_no: '(iv)',
            content: "Communication Skills",
            key: "communication_skills"
        },
        {
            s_no: '(v)',
            content: "Leadership Qualities",
            key: "leadership_qualities"
        },
        {
            s_no: '(vi)',
            content: "Capacity to work in team spirit",
            key: "capacity_to_work_in_team_spirit"
        },
        {
            s_no: '(vii)',
            content: "Capacity to work in time limit",
            key: "capacity_to_work_in_time_limit"
        },
        {
            s_no: '(viii)',
            content: "Inter-personal relations",
            key: "interpersonal_relations"
        }
    ]
    const assessment_of_functional = [
        {
            s_no: '(i)',
            content: "Knowledge Of Rules / Regulations /Procedures in the area of function and ability to apply them correctly",
            key: "knowledge_of_rules"
        },
        {
            s_no: '(ii)',
            content: "Strategic planning ability",
            key: "strategic_planning_activity"
        },
        {
            s_no: '(iii)',
            content: "Decision-making ability",
            key: "decision_making_ability"
        },
        {
            s_no: '(iv)',
            content: "Co-ordination ability",
            key: "coordination_ability"
        },
        {
            s_no: '(v)',
            content: "Ability to Motivate and develop subordinates",
            key: "ability_to_motivate_subordinates"
        }
    ]
    const selectInput4 = [
        {
            s_no: '1',
            content: "Has the teacher posses up-to-date knowledge of his subject?",
            key: "teacher_possess_upto_date_knowledge"
        },
        {
            s_no: '2',
            content: "Has the teacher completed the work assigned to him/ her?",
            key: "teacher_has_completed_the_work_assigned"
        },
        {
            s_no: '3',
            content: "Whether the teacher has the capacity for getting work out of his/ her subordinates and the relations with them?",
            key: "teacher_has_capacity_for_getting_work_with_subordinates"
        },
        {
            s_no: '4',
            content: "What is the teacher's bearing towards tarinees and his accessibility to them?",
            key: "teacher_bearing_towards_trainees_and_his_accessibility"
        },
        {
            s_no: '5',
            content: "Has the teacher maintained a reputation for integrity? (Give reasons for your answer, if it is in negative or doubtful)",
            key: "teacher_maintained_a_reputation_for_integrity"
        },
        {
            s_no: '6',
            content: "Has any incident occurred during the period under report which reflects credit or discredit on the teacher?",
            key: "any_incident_occured_during_the_period"
        }
    ]

    const assessment_of_work_total = assessment_of_work.map((item, i) => Number(apply[item?.key]) || 0).reduce((a, c) => a + c, 0) / assessment_of_work.length
    const assessment_of_personal_total = assessment_of_personal.map((item, i) => Number(apply[item?.key]) || 0).reduce((a, c) => a + c, 0) / assessment_of_personal.length
    const assessment_of_functional_total = assessment_of_functional.map((item, i) => Number(apply[item?.key]) || 0).reduce((a, c) => a + c, 0) / assessment_of_functional.length
    const director_assessment_of_work_total = assessment_of_work.map((item, i) => Number(apply1[item?.key + 1]) || 0).reduce((a, c) => a + c, 0) / assessment_of_work.length
    const director_assessment_of_personal_total = assessment_of_personal.map((item, i) => Number(apply1[item?.key + 1]) || 0).reduce((a, c) => a + c, 0) / assessment_of_personal.length
    const director_assessment_of_functional_total = assessment_of_functional.map((item, i) => Number(apply1[item?.key + 1]) || 0).reduce((a, c) => a + c, 0) / assessment_of_functional.length

    const apar_score = ((assessment_of_work_total * 40 / 100) + (assessment_of_personal_total * 30 / 100) + (assessment_of_functional_total * 30 / 100))
    const director_apar_score = ((director_assessment_of_work_total * 40 / 100) + (director_assessment_of_personal_total * 30 / 100) + (director_assessment_of_functional_total * 30 / 100))
    const defaultAparvalue = (isHodGenerate ? apar_score : apply?.hod_final_score)
    const DirectorAparValue = (!directorscore ? director_apar_score : apply?.final_score)
    return (
        <>
            <div className="">
                <section className="top-content-container">
                    <div className="my-4">
                        <div className="row">
                            <div className="col-lg-6">
                                <h6 className="headertext">{first_name}</h6>
                                <h6 className="subheadertext">{department}</h6>
                            </div>
                        </div>
                    </div>
                </section>
                <section>
                    <div className="row">
                        <div className="">
                            <div className="graphbox">
                                <div className="row">
                                    <div className="col-12 p-0 d-flex">
                                        <h6 className="labeltitle">
                                            <span
                                                className="arrowicon"
                                                onClick={() => {
                                                    navigate(-1);
                                                }}
                                            >
                                                ← &nbsp;
                                            </span>
                                            Annual Performance Assessment Report
                                        </h6>
                                    </div>
                                </div>
                                <div className="row mt-4">
                                    <div className="col-lg-3">
                                        <label className="labeltext"> Employee Name *</label>
                                        <div>
                                            {isHodGenerate ?
                                                <ReactSelect
                                                    value={apply?.employee_id}
                                                    onChange={(e) => {
                                                        setData(e, "employee_id");
                                                    }}
                                                    options={
                                                        employee
                                                    }
                                                />
                                                :
                                                <input
                                                    value={apply?.name}
                                                    disabled
                                                    className="fieldinput"
                                                />
                                            }
                                        </div>
                                        <small className="validationerror">
                                            {validation?.employee_id?.message
                                                ? `Employee ${validation?.employee_id?.message}`
                                                : ""}
                                        </small>
                                    </div>
                                    <div className="col-lg-3">
                                        <label className="labeltext"> Academic Year *</label>
                                        <div>
                                            {isHodGenerate ?
                                                <ReactSelect
                                                    isMulti={false}
                                                    value={{
                                                        label: apply.academic_year,
                                                        value: apply.academic_year,
                                                    }}
                                                    onChange={(selectedOption) =>
                                                        setData(selectedOption.value, "academic_year")
                                                    }
                                                    options={FinancialYearOptions()}
                                                /> :
                                                <input
                                                    value={apply?.academic_year}
                                                    disabled
                                                    className="fieldinput"
                                                />
                                            }
                                        </div>
                                        <small className="validationerror">
                                            {validation?.academic_year?.message
                                                ? `Year ${validation?.academic_year?.message}`
                                                : ""}
                                        </small>
                                    </div>
                                </div>
                                <div>
                                    <p className="fw-bold mt-4 mb-4">a. Assessment of Work Output (weightage to this Section would be 40%)<br /> Numerical grading is to be assigned by Reporting and Reviewing Authorities on a scale of 1 to 10(one to ten)</p>
                                    <table className="tablereport table-bordered w-100">
                                        <thead>
                                            <tr>
                                                <th scope="col">SI.No</th>
                                                <th>Items</th>
                                                <th>Reporting Authority</th>
                                                {(isDirector || isAdmin) && <th>Reporting Authority</th>}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {assessment_of_work.map((item, i) => {
                                                return (
                                                    <tr>
                                                        <td>{item?.s_no}</td>
                                                        <td
                                                            className={`${isHod ? 'w-75' : 'w-50'}`}
                                                        >{item?.content}</td>
                                                        <td className="text-center">
                                                            {isHodGenerate ?
                                                                <select
                                                                    className={`
                                                            fieldinput ${validation?.[item?.key]?.message ? 'validation-error' : ''}`}
                                                                    defaultValue={apply?.[item?.key]}
                                                                    onChange={(e) => setData(e.target.value, item?.key)}
                                                                >
                                                                    <option value=''>0</option>
                                                                    <option value={1}>1</option>
                                                                    <option value={2}>2</option>
                                                                    <option value={3}>3</option>
                                                                    <option value={4}>4</option>
                                                                    <option value={5}>5</option>
                                                                    <option value={6}>6</option>
                                                                    <option value={7}>7</option>
                                                                    <option value={8}>8</option>
                                                                    <option value={9}>9</option>
                                                                    <option value={10}>10</option>
                                                                </select>
                                                                : (apply?.assessment_of_work && apply?.assessment_of_work[item.key]?.hod_score || "-")
                                                            }
                                                        </td>
                                                        {(isDirector || isAdmin) &&
                                                            <td className="text-center">
                                                                {!directorscore ? isDirector ?
                                                                    <select
                                                                        className={`
                                                            fieldinput ${validation?.[item?.key + 1]?.message ? 'validation-error' : ''}`}
                                                                        defaultValue={apply1?.[item?.key + 1]}
                                                                        onChange={(e) => setData1(e.target.value, item?.key + 1)}
                                                                    >
                                                                        <option value=''>0</option>
                                                                        <option value={1}>1</option>
                                                                        <option value={2}>2</option>
                                                                        <option value={3}>3</option>
                                                                        <option value={4}>4</option>
                                                                        <option value={5}>5</option>
                                                                        <option value={6}>6</option>
                                                                        <option value={7}>7</option>
                                                                        <option value={8}>8</option>
                                                                        <option value={9}>9</option>
                                                                        <option value={10}>10</option>
                                                                    </select>
                                                                    : (apply?.[item.key + 1] || "-")
                                                                    : (apply?.assessment_of_work && apply?.assessment_of_work[item.key]?.director_score || "-")
                                                                }
                                                            </td>
                                                        }
                                                    </tr>
                                                )
                                            })}
                                        </tbody>
                                        <tfoot>
                                            <tr>
                                                <td></td>
                                                <td className="fw-bold">Overall Grading On Personal Attributes</td>
                                                <td className="fw-bold text-center" style={{ fontSize: '18px' }}>
                                                    {isHodGenerate ? assessment_of_work_total :
                                                        apply?.assessment_of_work_hod_total_score}
                                                </td>
                                                {(isDirector || isAdmin) &&
                                                    <td className="fw-bold text-center" style={{ fontSize: '18px' }}>
                                                        {!directorscore
                                                            ? director_assessment_of_work_total
                                                            : apply?.assessment_of_work_director_total_score}
                                                    </td>
                                                }
                                            </tr>
                                        </tfoot>
                                    </table>
                                </div>
                                <div>
                                    <p className="fw-bold mt-5 mb-4">b. Assessment of Personal Attributes (weightage to this Section would be 30%)<br /> Numerical grading is to be assigned by Reporting and Reviewing Authorities on a scale of 1 to 10(one to ten)</p>
                                    <table className="tablereport table-bordered w-100">
                                        <thead>
                                            <tr>
                                                <th scope="col">SI.No</th>
                                                <th
                                                    className={`${isHod ? 'w-75' : 'w-50'}`}
                                                >Items</th>
                                                <th>Reporting Authority</th>
                                                {(isDirector || isAdmin) && <th>Reporting Authority</th>}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {assessment_of_personal.map((item, i) => {
                                                return (
                                                    <tr>
                                                        <td>{item?.s_no}</td>
                                                        <td>{item?.content}</td>
                                                        <td className="text-center">
                                                            {isHodGenerate ?
                                                                <select
                                                                    className={`
                                                            fieldinput ${validation?.[item?.key]?.message ? 'validation-error' : ''}`}
                                                                    defaultValue={apply?.[item?.key]}
                                                                    onChange={(e) => setData(e.target.value, item?.key)}
                                                                >
                                                                    <option value=''>0</option>
                                                                    <option value={1}>1</option>
                                                                    <option value={2}>2</option>
                                                                    <option value={3}>3</option>
                                                                    <option value={4}>4</option>
                                                                    <option value={5}>5</option>
                                                                    <option value={6}>6</option>
                                                                    <option value={7}>7</option>
                                                                    <option value={8}>8</option>
                                                                    <option value={9}>9</option>
                                                                    <option value={10}>10</option>
                                                                </select>
                                                                : (apply?.assessment_of_personal_attributes && apply?.assessment_of_personal_attributes[item.key]?.hod_score || "-")
                                                            }
                                                        </td>
                                                        {(isDirector || isAdmin) &&
                                                            <td className="text-center">
                                                                {!directorscore ? isDirector ?
                                                                    <select
                                                                        className={`
                                                            fieldinput ${validation?.[item?.key + 1]?.message ? 'validation-error' : ''}`}
                                                                        defaultValue={apply1?.[item?.key + 1]}
                                                                        onChange={(e) => setData1(e.target.value, item?.key + 1)}
                                                                    >
                                                                        <option value=''>0</option>
                                                                        <option value={1}>1</option>
                                                                        <option value={2}>2</option>
                                                                        <option value={3}>3</option>
                                                                        <option value={4}>4</option>
                                                                        <option value={5}>5</option>
                                                                        <option value={6}>6</option>
                                                                        <option value={7}>7</option>
                                                                        <option value={8}>8</option>
                                                                        <option value={9}>9</option>
                                                                        <option value={10}>10</option>
                                                                    </select>
                                                                    : (apply?.[item.key + 1] || "-")
                                                                    : (apply?.assessment_of_personal_attributes && apply?.assessment_of_personal_attributes[item.key]?.director_score || "-")
                                                                }
                                                            </td>
                                                        }
                                                    </tr>
                                                )
                                            })}
                                        </tbody>
                                        <tfoot>
                                            <tr>
                                                <td></td>
                                                <td className="fw-bold">Overall Grading On Personal Attributes</td>
                                                <td className="fw-bold text-center" style={{ fontSize: '18px' }}>
                                                    {isHodGenerate ? assessment_of_personal_total : apply?.assessment_of_personal_attributes_hod_total_score}
                                                </td>
                                                {(isDirector || isAdmin) &&
                                                    <td className="fw-bold text-center" style={{ fontSize: '18px' }}>
                                                        {!directorscore
                                                            ? director_assessment_of_personal_total
                                                            : apply?.assessment_of_personal_attributes_director_total_score}
                                                    </td>
                                                }
                                            </tr>
                                        </tfoot>
                                    </table>
                                </div>
                                <div>
                                    <p className="fw-bold mt-5 mb-4">c. Assessment of functional competency (weightage to this Section would be 30%)<br /> Numerical grading is to be assigned by Reporting and Reviewing Authorities on a scale of 1 to 10(one to ten)</p>
                                    <table className="tablereport table-bordered w-100">
                                        <thead>
                                            <tr>
                                                <th scope="col">SI.No</th>
                                                <th className={`${isHod ? 'w-75' : 'w-50'}`}>Items</th>
                                                <th>Reporting Authority</th>
                                                {(isDirector || isAdmin) && <th>Reporting Authority</th>}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {assessment_of_functional.map((item, i) => {
                                                return (
                                                    <tr>
                                                        <td>{item?.s_no}</td>
                                                        <td
                                                            className=""
                                                        >{item?.content}</td>
                                                        <td className="text-center">
                                                            {isHodGenerate ?
                                                                <select
                                                                    className={`
                                                            fieldinput ${validation?.[item?.key]?.message ? 'validation-error' : ''}`}
                                                                    defaultValue={apply?.[item?.key]}
                                                                    onChange={(e) => setData(e.target.value, item?.key)}
                                                                >
                                                                    <option value=''>0</option>
                                                                    <option value={1}>1</option>
                                                                    <option value={2}>2</option>
                                                                    <option value={3}>3</option>
                                                                    <option value={4}>4</option>
                                                                    <option value={5}>5</option>
                                                                    <option value={6}>6</option>
                                                                    <option value={7}>7</option>
                                                                    <option value={8}>8</option>
                                                                    <option value={9}>9</option>
                                                                    <option value={10}>10</option>
                                                                </select>
                                                                : (apply?.assessment_of_functional_competency && apply?.assessment_of_functional_competency[item.key]?.hod_score || "-")
                                                            }
                                                        </td>
                                                        {(isDirector || isAdmin) &&
                                                            <td className="text-center">
                                                                {!directorscore ? isDirector ?
                                                                    <select
                                                                        className={`
                                                            fieldinput ${validation?.[item?.key + 1]?.message ? 'validation-error' : ''}`}
                                                                        defaultValue={apply1?.[item?.key + 1]}
                                                                        onChange={(e) => setData1(e.target.value, item?.key + 1)}
                                                                    >
                                                                        <option value=''>0</option>
                                                                        <option value={1}>1</option>
                                                                        <option value={2}>2</option>
                                                                        <option value={3}>3</option>
                                                                        <option value={4}>4</option>
                                                                        <option value={5}>5</option>
                                                                        <option value={6}>6</option>
                                                                        <option value={7}>7</option>
                                                                        <option value={8}>8</option>
                                                                        <option value={9}>9</option>
                                                                        <option value={10}>10</option>
                                                                    </select>
                                                                    : (apply?.[item.key + 1] || "-")
                                                                    : (apply?.assessment_of_functional_competency && apply?.assessment_of_functional_competency[item.key]?.director_score || "-")

                                                                }
                                                            </td>
                                                        }
                                                    </tr>
                                                )
                                            })}
                                        </tbody>
                                        <tfoot>
                                            <tr>
                                                <td></td>
                                                <td className="fw-bold">Overall Grading On Functional Competency</td>
                                                <td className="fw-bold text-center" style={{ fontSize: '18px' }}>
                                                    {isHodGenerate ? assessment_of_functional_total : apply?.assessment_of_functional_competency_hod_total_score}
                                                </td>
                                                {(isDirector || isAdmin) &&
                                                    <td className="fw-bold text-center" style={{ fontSize: '18px' }}>
                                                        {!directorscore
                                                            ? director_assessment_of_functional_total
                                                            : apply?.assessment_of_functional_competency_director_total_score}
                                                    </td>
                                                }
                                            </tr>
                                        </tfoot>
                                    </table>
                                </div>
                                <div className="mt-5 pt-5">
                                    <table className="tablereport table-bordered w-100">
                                        <thead>
                                            <tr>
                                                <th scope="col">SI.No</th>
                                                <th className="w-75">Points on which views should be recorded</th>
                                                <th>Views</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {selectInput4.map((item, i) => {
                                                return (
                                                    <tr>
                                                        <td className="text-center" style={{ width: '7%' }}>{item?.s_no}</td>
                                                        <td style={{ width: '64%' }}>{item?.content}</td>
                                                        <td className="text-center">
                                                            {isHodGenerate ?
                                                                <input
                                                                    name={item?.key}
                                                                    className={`w-100
                                                                fieldinput ${validation?.[item?.key]?.message ? 'validation-error' : ''}`}
                                                                    value={apply && apply[item?.key]}
                                                                    placeholder="Enter views"
                                                                    onChange={(e) => setData(e.target.value, item?.key)}
                                                                /> :
                                                                (apply?.views_of_points && apply?.views_of_points[item?.key])
                                                            }
                                                        </td>
                                                    </tr>
                                                )
                                            })}
                                        </tbody>
                                    </table>
                                </div>
                                <p className="mt-4">
                                    Comment clearly on the overall qualities of the faculty member (in about 100 word) including area of strength and lesser strength, extraordinary achievements, significant failures by the Reporting Officer (Head of the Department):
                                </p>
                                <p className="mt-5 pt-3 fw-bold"> Overall Numerical grading in the basis of weightage given in a,b and c of APAR
                                    <input
                                        disabled
                                        value={isHod ? defaultAparvalue : DirectorAparValue}
                                        className="fieldinput ms-4 w-auto"
                                    />
                                </p>
                                {(isHodGenerate || (isDirector && !directorscore)) &&
                                    <>
                                        <div className="my-5 checkbox-apar"  >
                                            <input
                                                type="checkbox"
                                                checked={apply?.ckeck}
                                                onChange={isHod ?
                                                    ((e) => setData(e.target.checked, "condition_acknowledge"))
                                                    : isDirector &&
                                                    ((e) => setData1(e.target.checked, "director_condition_acknowledge"))
                                                }
                                            />
                                            <label className="ms-3">I confirm that the information provided above is accurate to the best of my knowledge.</label>
                                        </div>
                                        <div className="text-center mt-4">
                                            <button className="requestbtn" onClick={isHod ? handleSubmit : isDirector && handleDirectorSubmit}>Submit</button>
                                        </div>
                                    </>
                                }
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </>
    );
};

export default HodAPAReportGenerate;
